export default __webpack_public_path__ + "d8df5d63dc6b4eadd013481e1b3216b5.png";